import React, { useState, useEffect, useContext } from "react";
import { css } from "emotion";
import { boxStyles, colors, textSizes } from "../../styles/theme";
import { BuildContext } from "../../context/BuildSpotlightState";

const Circle = ({
  index,
  currentStep,
  iconActive,
  iconInactive,
  handleClick,
}) => {
  const { lastCompleted } = useContext(BuildContext);

  return (
    <div className={container + ` ${lastCompleted >= index && "active"}`}>
      {iconInactive && (
        <div className="iconInactive">
          <img src={iconInactive} />
        </div>
      )}

      <div className="circleMask" onClick={handleClick}>
        <div className="filledCircle">
          <img src={iconActive} />
        </div>
      </div>
    </div>
  );
};

export default Circle;

const container = css`
  width: 45px;
  height: 45px;
  position: relative;

  .iconInactive {
    position: absolute;
    left: 50%;
    top: 55%;
    transform: translate(-50%, -50%);
    z-index: -1;
  }

  .circleMask {
    width: 0;
    overflow: hidden;
    height: 45px;
    transition-duration: 0.9s;
    transition-delay: 0.15s;
  }

  img {
    width: 20px;
    height: 20px;
  }

  .filledCircle {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    width: 35px;
    background-color: ${colors.brandColor};
    border-radius: 50%;
    z-index: 10;
    margin-left: 5px;
    margin-top: 5px;
    box-shadow: 0 0 0 0 transparent;
    transition-duration: .5s;
    
    &:hover {
      box-shadow: 0 0 0 5px ${colors.brandColor};
    }

    img {
      margin-left: 0 0 1px 1px;
    }
  }

  &.active {
    .circleMask {
      width: 45px;
      cursor: pointer;
    }
  }
`;
